import { Injectable } from '@angular/core';
import { CommonApi } from 'src/app/lib/services/api/common.api';
import { environment } from 'src/environments/environment';
import { ApiUrls, Constants } from 'src/app/config/constants';
import { StorageService } from './storage.service';
import { CommonService } from './common.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(
    private commonApi: CommonApi,
    private commonService: CommonService,
    private storageservice: StorageService,
  ) { }

  getUid() {
    return this.commonService.parseJwt(this.storageservice.getItem(Constants.AUTH_TOKEN)).userId;
  }

  getUserImageUploadUrl() {
    return this.commonApi.getDataByUrl(environment.baseUrl + ApiUrls.image);
  }

  getUserProfileImageUploadUrl() {
    return this.commonApi.getDataByUrl(environment.baseUrl + ApiUrls.profileUpload);
  }

  getUserDetails() {
    return this.commonApi.getData(`${ApiUrls.user}/${this.getUid()}`);
  }

  uploadFile(selectedFile: File, url: string) {
    // return this.commonApi.putData(endpoint, formData);
  }

  uploadqr(selectedFile: File, url: string) {
    const endpoint = 'https://s3.ap-south-1.amazonaws.com/dev.sarvm.com/documents/ums/qr_code_image/';
    const formData: FormData = new FormData();
    formData.append('fileKey', selectedFile, selectedFile.name);
    return this.commonApi.putData(endpoint, formData);
  }

  addUserDetails(formData: any) {
    return this.commonApi.putData(`${ApiUrls.user}/${this.getUid()}`, formData);
  }

  getUPI(userId: any) {
    return this.commonApi.getData(`${ApiUrls.userDetails.retailerUpi}/${userId}/paymentInfo`);
  }

  createUPI(userId: any, form: any) {
    return this.commonApi.postData(`${ApiUrls.userDetails.retailerUpi}/${userId}/paymentInfo`, form);
  }

  updateUPI(retailerId: any, paymentInfoId: any, form: any) {
    return this.commonApi.putData(`${ApiUrls.userDetails.retailerUpi}/${retailerId}/paymentInfo/${paymentInfoId}`, form);
  }

  deleteUPI(retailerId: any, paymentInfoId: any) {
    return this.commonApi.deleteData(`${ApiUrls.userDetails.retailerUpi}/${retailerId}/paymentInfo/${paymentInfoId}`);
  }

  deleteAccount(id: any) {
    return this.commonApi.deleteData(`${ApiUrls.userDetails.user}/${id}`);
  }

  deleteUserAccount(id: any, payload: any) {
    return this.commonApi.deleteAccount(`${ApiUrls.userDetails.user}/${id}`, payload);
  }

  getQrCodeImageUploadUrl() {
    return this.commonApi.getDataByUrl(environment.baseUrl + ApiUrls.userDetails.qrCodeUpload);
  }

  setRating(ratingData: any) {
    return this.commonApi.putRatingData(`${ApiUrls.user}/addToRating`, ratingData);
  }

  getPhoneNumber(uuid: string) {
    return this.commonApi.getData(`${ApiUrls.userDetails.phoneNumber}/${uuid}`);
  }

  validatePhone(formData: any) {
    return this.commonApi.postData(`${ApiUrls.userDetails.validatePhoneApi}`, formData);
  }

  addFavourite(formData: any) {
    return this.commonApi.postData(`${ApiUrls.favourites}/${this.getUid()}`, formData);
  }

  updateSettings(id: any, payload: any) {
    return this.commonApi.putData(`${ApiUrls.updateShopCharges}${id}`, payload);
  }
}
